import { SubMenuList } from '../sub-menu-list';

export class AutomationLogsButton extends SubMenuList {
  name = 'automation-logs';
}

export class AutomationRulesButton extends SubMenuList {
  name = 'automation-rules';
}
